import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("legashield_token");
    if (token) {
        cfg.headers = cfg.headers || {};
        cfg.headers["Authorization"] = `Bearer ${token}`;
    }
    return cfg;
});
